import { StrategyDetailsPageListDocumentRecordsQuery } from '@/__generated__/graphql';
import { Loader } from '@/components/loaders/loader';
import { updatesTableColumnsEditMode } from '@/components/managerUpdates-page/constants';
import NoResults from '@/components/table/noResults';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { IItems, ISort } from '@/components/table/types';
import styled from 'styled-components';
import { TableBody } from './tableBody';

interface TableProp {
  tableData: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'];
  sort: ISort;
  loading: boolean;
  setSort: (value: ISort) => void;
  dropdownActions: (row: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'][number]) => IItems[];
  openEditManagerUpdatePage: (updateId: string) => void;
}

export const Table = ({ tableData, sort, loading, setSort, dropdownActions, openEditManagerUpdatePage }: TableProp) => {
  return (
    <TableWrapper padding="0">
      <CustomTableHeader refetch={() => {}} columns={updatesTableColumnsEditMode} savedSort={sort} savedSetSort={setSort} />
      <TableBodyWrapper>
        {loading ? (
          <Loader />
        ) : (
          <>
            {!tableData.length ? (
              <NoResults />
            ) : (
              <TableBody tableData={tableData} dropdownActions={dropdownActions} openEditManagerUpdatePage={openEditManagerUpdatePage} />
            )}
          </>
        )}
      </TableBodyWrapper>
    </TableWrapper>
  );
};

const CustomTableHeader = styled(TableHeader)`
  #tableColumnTitle {
    flex-basis: auto;
  }
`;
